module.exports = ".body-overlay{\r\n    position: fixed;\r\n            width: 100%;\r\n            height: 100%;\r\n            top: 0;\r\n            left: 0;\r\n            right: 0;\r\n            bottom: 0;\r\n            background-color: rgba(0,0,0,0.5);\r\n            z-index: 9999;\r\n            cursor: default;\r\n}\r\n\r\n.overlay{\r\n      z-index: 99999;\r\n}\r\n\r\nh1{\r\n    color: #e60000;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/stubs-data-add/stubs-data-add.component.css
// module id = ./src/app/stubs-data-add/stubs-data-add.component.css
// module chunks = main